import React from 'react';

import { Box, Typography } from '@mui/material';

import Eyebrow from '../Eyebrow';

// Stitch page opener: eyebrow pill, display heading, intro, optional chips or aside,
// over a faint grid with a soft glow.
export default function PageHero({
  eyebrow,
  title,
  intro,
  children,
  aside,
}: {
  eyebrow: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  children?: React.ReactNode;
  aside?: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        position: 'relative',
        py: { xs: 5, md: 9 },
        display: 'grid',
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: aside ? 'minmax(0, 1fr) 20rem' : '1fr' },
        alignItems: 'end',
        gap: 4,
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          zIndex: -1,
          pointerEvents: 'none',
          background:
            'radial-gradient(40rem 20rem at 70% 30%, rgba(213, 227, 255, 0.55), transparent 70%)',
        },
      }}
    >
      <Box sx={{ maxWidth: '52rem' }}>
        <Eyebrow>{eyebrow}</Eyebrow>
        <Typography
          component='h1'
          variant='h1'
          sx={{ mt: 2.5 }}
        >
          {title}
        </Typography>
        {intro && (
          <Typography
            variant='bodyLg'
            component='p'
            sx={{ mt: 3, maxWidth: '40rem' }}
          >
            {intro}
          </Typography>
        )}
        {children}
      </Box>
      {aside}
    </Box>
  );
}
